import React from 'react';

import PageLoader from '../../components/Common/loader/PageLoader';
import Filters from '../../components/Common/Filters/Filters';
import RunRatePlanTable from './RunRatePlanTable';

interface Props {
    history: any;
}

interface State {
    isLoading: boolean;
    isFilterApplied: boolean;
    isCallRequired: boolean;
    isTableLoading: boolean;
    historicRRWeeks: number;
}

export default class RunRatePlan extends React.Component<Props, State> {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            isFilterApplied: false,
            isCallRequired: false,
            isTableLoading: true,
            historicRRWeeks: 12
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.isTableLoading !== this.state.isTableLoading) {
            this.setState({ isLoading: this.state.isTableLoading });
        }
    }

    render(): React.ReactNode {
        return (
            <React.Fragment>
                <div className="page-content">

                    <PageLoader
                        status={this.state.isLoading}
                    />

                    <Filters
                        timeSelection={'multi'}
                        history={this.props.history}
                        onUpdateFilter={() => {
                            this.setState({
                                isFilterApplied: true,
                                isCallRequired: true,
                                isLoading: true,
                                isTableLoading: true
                            });
                        }}
                    />

                    {
                        this.state.isFilterApplied &&
                        <RunRatePlanTable
                            historicRRWeeks={this.state.historicRRWeeks}
                            history={this.props.history}
                            isCallRequired={this.state.isCallRequired}
                            onLoadEnd={() => {
                                this.setState({
                                    isCallRequired: false,
                                    isTableLoading: false
                                });
                            }}
                        />
                    }

                    {
                        !this.state.isFilterApplied && (
                            <div className="d-flex justify-content-center align-items-center"
                                 style={{ minHeight: '400px' }}>
                                <div className="text-center">
                                    <i className="ri-filter-3-line font-size-48 text-muted mb-3 d-block"></i>
                                    <h5 className="text-muted">Please click Apply Button to view Grid</h5>
                                </div>
                            </div>
                        )
                    }

                </div>
            </React.Fragment>
        );
    }
}
